import { render, staticRenderFns } from "./LayerMapCompare.vue?vue&type=template&id=636b3b71&scoped=true"
import script from "./LayerMapCompare.vue?vue&type=script&lang=js"
export * from "./LayerMapCompare.vue?vue&type=script&lang=js"
import style0 from "./LayerMapCompare.vue?vue&type=style&index=0&id=636b3b71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b3b71",
  null
  
)

export default component.exports